// Feste Texte für PDF- und CSV-Berichte (E12). Eingaben der Nutzer,
// Normkürzel und die Oberfläche bleiben außen vor. Beide Sprachen müssen
// dieselben Schlüssel und Platzhalter haben (reportTexts.test.js).

const de = {
  'pdf.date': 'Datum: {d}',
  'pdf.reportNo': 'Bericht-Nr.: {nr}',
  'pdf.title': 'Toleranzanalyse',
  'pdf.project': 'Projekt: {name}',
  'pdf.calculation': 'Berechnung: {tag}',
  'pdf.method': 'Methode: {m}',
  'method.worstcase.long': 'Worst Case (Arithmetisch)',
  'method.rss.long': 'RSS (Root Sum Square - Statistisch)',
  'method.montecarlo.long': 'Monte-Carlo-Simulation',
  'status.pass': 'OK',
  'status.fail': 'NOK',
  'pdf.hero.noLimits': 'Berechnung ohne Soll-Grenzen',
  'pdf.hero.noLimitsHint': '(keine Soll-Limits hinterlegt)',
  'pdf.hero.tolerance': 'Toleranzfeld ({m}): {v} mm',
  'pdf.hero.range': 'SCHLIESSMASS-BEREICH',
  'pdf.hero.nominal': 'Nennmaß (M0): {v} mm',
  'pdf.sketch': 'Skizze',
  'pdf.chain.title': 'Maßkette - Einzelelemente',
  'pdf.chain.inactive': '(inaktiv)',
  'pdf.chain.head.nr': 'Nr.',
  'pdf.chain.head.name': 'Bez.',
  'pdf.chain.head.nominal': 'Nennmaß [mm]',
  'pdf.chain.head.tol': 'Toleranz',
  'pdf.chain.head.range': 'Tol.feld [mm]',
  'pdf.chain.head.dir': 'Wirk.',
  'pdf.chain.head.norm': 'Norm',
  'pdf.chain.disabled.one': '{n} Maß deaktiviert, nicht in der Berechnung enthalten.',
  'pdf.chain.disabled.many': '{n} Maße deaktiviert, nicht in der Berechnung enthalten.',
  'pdf.contrib.title': 'Beitragsleister',
  'pdf.contrib.range': 'Toleranzfeld',
  'pdf.contrib.share': 'Anteil',
  'pdf.contrib.share.rss': 'Anteil (RSS)',
  'pdf.contrib.share.mc': 'Anteil (MC)',
  'pdf.contrib.m0': 'M0-Toleranzfeld ({m}): {v} mm',
  'pdf.contrib.hint.rss': 'Anteile als Varianz-Beitrag (statistische Kombination)',
  'pdf.contrib.hint.mc': 'Anteile als Varianz-Beitrag je Verteilung (Monte Carlo)',
  'pdf.result.title': 'Ergebnis-Detail',
  'pdf.result.tolStat': 'Toleranzfeld ({m} - statistische Kombination)',
  'pdf.result.tolWc': 'Toleranzfeld ({m} - Maxmaß - Minmaß)',
  'pdf.result.limitMin': 'Soll-Limit Minimum',
  'pdf.result.limitMax': 'Soll-Limit Maximum',
  'pdf.mc.title': 'Monte-Carlo · Statistik-Detail',
  'pdf.mc.meta': 'Samples: {n}  ·  Konfidenz: {conf} ({sigma}){seed}',
  'pdf.mc.seed': '  ·  Seed: {s}',
  'pdf.mc.unseeded': '  ·  ungeseedet (Math.random)',
  'pdf.mc.mean': 'Mittelwert (mu)',
  'pdf.mc.stddev': 'Streuung (sigma)',
  'pdf.mc.bannerBad': 'Cpk < {c} - Prozess nicht fähig. Streuung zu groß oder Mitte zu weit von der Soll-Mitte.',
  'pdf.mc.bannerWarn': 'Cpk < {c} - Prozess nur grenzfähig. Statistisch geprüfte Toleranz ist knapp.',
  'pdf.mc.histogram': 'Verteilung von M0',
  'cpk.line': 'Prozessfähigkeit je Maß: {list}',
  'cpk.item': 'Nr. {nr} Cpk {c}',
  'cpk.others': 'übrige {c}',
  'pdf.approval.title': 'Freigabe',
  'pdf.approval.created': 'Erstellt',
  'pdf.approval.checked': 'Geprüft',
  'pdf.approval.approved': 'Freigegeben',
  'pdf.approval.date': 'Datum:',
  'pdf.page': 'Seite {p} von {n}',
  'dist.normal': 'Normal',
  'dist.uniform': 'Gleich',
  'dist.triangular': 'Dreieck',
  'csv.col.label': 'Bezeichnung',
  'csv.col.nominal': 'Nennmaß',
  'csv.col.upper': 'Oberes Abmaß',
  'csv.col.lower': 'Unteres Abmaß',
  'csv.col.tolerance': 'Toleranzfeld',
  'csv.col.direction': 'Wirkrichtung',
  'csv.col.active': 'Aktiv',
  'csv.col.norm': 'Norm',
  'csv.col.distribution': 'Verteilung',
  'csv.col.contribution': 'Beitrag (%)',
  'csv.col.comment': 'Kommentar',
  'csv.yes': 'ja',
  'csv.no': 'nein',
  'csv.result': 'Ergebnis Schließmaß M₀',
  'csv.method': 'Methode',
  'csv.method.worstcase': 'Worst Case',
  'csv.method.rss': 'RSS (Statistisch)',
  'csv.method.montecarlo': 'Monte Carlo',
  'csv.limitMin': 'Limit Min',
  'csv.limitMax': 'Limit Max',
  'csv.mc.title': 'Monte-Carlo-Statistik',
  'csv.mc.confidence': 'Konfidenz',
  'csv.mc.mean': 'Mittelwert (µ)',
  'csv.mc.stddev': 'Streuung (σ)',
  'csv.mc.percentile': 'Perzentil {p}',
  'csv.mc.median': 'Perzentil p50 (Median)',
  'version.named': 'Stand: {label} vom {stamp}',
  'version.auto': 'Stand vom {stamp}',
  'file.fallback': 'toleranzanalyse',
};

const en = {
  'pdf.date': 'Date: {d}',
  'pdf.reportNo': 'Report No.: {nr}',
  'pdf.title': 'Tolerance Stack-Up Analysis',
  'pdf.project': 'Project: {name}',
  'pdf.calculation': 'Calculation: {tag}',
  'pdf.method': 'Method: {m}',
  'method.worstcase.long': 'Worst Case (Arithmetic)',
  'method.rss.long': 'RSS (Root Sum Square - Statistical)',
  'method.montecarlo.long': 'Monte Carlo Simulation',
  'status.pass': 'PASS',
  'status.fail': 'FAIL',
  'pdf.hero.noLimits': 'Calculation without specification limits',
  'pdf.hero.noLimitsHint': '(no specification limits defined)',
  'pdf.hero.tolerance': 'Tolerance range ({m}): {v} mm',
  'pdf.hero.range': 'RESULTING RANGE',
  'pdf.hero.nominal': 'Nominal (M0): {v} mm',
  'pdf.sketch': 'Sketch',
  'pdf.chain.title': 'Dimension Chain - Elements',
  'pdf.chain.inactive': '(inactive)',
  'pdf.chain.head.nr': 'No.',
  'pdf.chain.head.name': 'Desc.',
  'pdf.chain.head.nominal': 'Nominal [mm]',
  'pdf.chain.head.tol': 'Tolerance',
  'pdf.chain.head.range': 'Tol. range [mm]',
  'pdf.chain.head.dir': 'Dir.',
  'pdf.chain.head.norm': 'Standard',
  'pdf.chain.disabled.one': '{n} dimension disabled, not included in the calculation.',
  'pdf.chain.disabled.many': '{n} dimensions disabled, not included in the calculation.',
  'pdf.contrib.title': 'Contribution Chart',
  'pdf.contrib.range': 'Tolerance range',
  'pdf.contrib.share': 'Share',
  'pdf.contrib.share.rss': 'Share (RSS)',
  'pdf.contrib.share.mc': 'Share (MC)',
  'pdf.contrib.m0': 'M0 tolerance range ({m}): {v} mm',
  'pdf.contrib.hint.rss': 'Shares as variance contribution (statistical combination)',
  'pdf.contrib.hint.mc': 'Shares as variance contribution per distribution (Monte Carlo)',
  'pdf.result.title': 'Result Details',
  'pdf.result.tolStat': 'Tolerance range ({m} - statistical combination)',
  'pdf.result.tolWc': 'Tolerance range ({m} - max - min)',
  'pdf.result.limitMin': 'Lower specification limit (LSL)',
  'pdf.result.limitMax': 'Upper specification limit (USL)',
  'pdf.mc.title': 'Monte Carlo · Statistics',
  'pdf.mc.meta': 'Samples: {n}  ·  Confidence: {conf} ({sigma}){seed}',
  'pdf.mc.seed': '  ·  Seed: {s}',
  'pdf.mc.unseeded': '  ·  unseeded (Math.random)',
  'pdf.mc.mean': 'Mean (mu)',
  'pdf.mc.stddev': 'Standard deviation (sigma)',
  'pdf.mc.bannerBad': 'Cpk < {c} - process not capable. Spread too large or mean too far from target.',
  'pdf.mc.bannerWarn': 'Cpk < {c} - process marginally capable. Statistically verified tolerance is tight.',
  'pdf.mc.histogram': 'Distribution of M0',
  'cpk.line': 'Process capability per dimension: {list}',
  'cpk.item': 'No. {nr} Cpk {c}',
  'cpk.others': 'others {c}',
  'pdf.approval.title': 'Approval',
  'pdf.approval.created': 'Prepared by',
  'pdf.approval.checked': 'Checked by',
  'pdf.approval.approved': 'Approved by',
  'pdf.approval.date': 'Date:',
  'pdf.page': 'Page {p} of {n}',
  'dist.normal': 'Normal',
  'dist.uniform': 'Uniform',
  'dist.triangular': 'Triangular',
  'csv.col.label': 'Description',
  'csv.col.nominal': 'Nominal',
  'csv.col.upper': 'Upper deviation',
  'csv.col.lower': 'Lower deviation',
  'csv.col.tolerance': 'Tolerance range',
  'csv.col.direction': 'Direction',
  'csv.col.active': 'Active',
  'csv.col.norm': 'Standard',
  'csv.col.distribution': 'Distribution',
  'csv.col.contribution': 'Contribution (%)',
  'csv.col.comment': 'Comment',
  'csv.yes': 'yes',
  'csv.no': 'no',
  'csv.result': 'Resulting Dimension M₀',
  'csv.method': 'Method',
  'csv.method.worstcase': 'Worst Case',
  'csv.method.rss': 'RSS (Statistical)',
  'csv.method.montecarlo': 'Monte Carlo',
  'csv.limitMin': 'LSL',
  'csv.limitMax': 'USL',
  'csv.mc.title': 'Monte Carlo Statistics',
  'csv.mc.confidence': 'Confidence',
  'csv.mc.mean': 'Mean (µ)',
  'csv.mc.stddev': 'Standard deviation (σ)',
  'csv.mc.percentile': 'Percentile {p}',
  'csv.mc.median': 'Percentile p50 (Median)',
  'version.named': 'Revision: {label} of {stamp}',
  'version.auto': 'Revision of {stamp}',
  'file.fallback': 'tolerance_analysis',
};

export const REPORT_TEXTS = { de, en };

export function normLang(value) {
  return value === 'en' ? 'en' : 'de';
}

export function rt(lang, key, params) {
  const text = REPORT_TEXTS[normLang(lang)][key] ?? REPORT_TEXTS.de[key] ?? key;
  if (!params) return text;
  return text.replace(/\{(\w+)\}/g, (m, name) => (name in params ? String(params[name]) : m));
}

export function numLocale(lang) {
  return normLang(lang) === 'en' ? 'en-US' : 'de-DE';
}

const zwei = (n) => String(n).padStart(2, '0');

export function fmtDate(lang, date) {
  if (normLang(lang) === 'en') return `${date.getFullYear()}-${zwei(date.getMonth() + 1)}-${zwei(date.getDate())}`;
  return date.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

export function fmtStamp(lang, iso) {
  const d = new Date(iso);
  if (normLang(lang) === 'en') return `${fmtDate('en', d)} ${zwei(d.getHours())}:${zwei(d.getMinutes())}`;
  return d.toLocaleString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function fmtInt(lang, n) {
  return Number(n).toLocaleString(numLocale(lang));
}
